export default "__VITE_ASSET__CE2g8z2X__"